import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-58f06ac1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = { class: "grid-layout" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c0" }, null, -1))
const _hoisted_7 = { class: "caja c1" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cliente: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Desde: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Hasta: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_13 = { class: "caja c2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold" }, [
  /*#__PURE__*/_createTextVNode(" Lote de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Reclamaciones ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "No: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_17 = { class: "table table-hover" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Aseguradora"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Autorización"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "NSS"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Paciente"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Tipo Servicio"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "t izq bold" }
const _hoisted_22 = { class: "t izq bold" }
const _hoisted_23 = { class: "t izq bold" }
const _hoisted_24 = { class: "bold" }
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "bold" }
const _hoisted_27 = { class: "bold der" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "bold izq bold" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_33 = { class: "bold der" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(this.documento.medico), 1),
          _createElementVNode("h5", null, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.documento.descCliente), 1)
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaDesde)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDatePlus(this.documento.fechaHasta)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaProceso)), 1)
          ], 512), [
            [_vShow, !_ctx.mostrarFechas()]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("h5", null, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatSecuence(this.documento.no)), 1)
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaProceso)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_17, [
        (this.reclams)
          ? (_openBlock(), _createElementBlock("thead", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclams, (reclam, index) => {
          return (_openBlock(), _createElementBlock("tbody", { key: index }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(reclam.aseguradora), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_25, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(reclam.tipoServicio), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ])
          ]))
        }), 128)),
        _createElementVNode("tbody", null, [
          (this.totales.documentos)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                _createElementVNode("td", _hoisted_29, " Total: " + _toDisplayString(_ctx.formatNumber2(this.totales.documentos)), 1),
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatNumber(this.totales.reclamacion)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}